import React from 'react';

const DashBoardHome = () => {
    return (
        <div>
            <h3>Please select a topic.</h3>
        </div>
    );
};

export default DashBoardHome;